import { render, staticRenderFns } from "./IbanDataCheck.vue?vue&type=template&id=2e663eea&scoped=true"
import script from "./IbanDataCheck.vue?vue&type=script&lang=ts"
export * from "./IbanDataCheck.vue?vue&type=script&lang=ts"
import style0 from "./IbanDataCheck.vue?vue&type=style&index=0&id=2e663eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e663eea",
  null
  
)

export default component.exports